(() => {
  const selector = '[data-ht-quick-add-limit="true"]';
  const quickAddSelector = '.quick-add__submit[name="add"]';
  let cartRequest = null;
  let refreshTimer = null;
  let loadingTimer = null;

  const labelFor = (button) => button.querySelector('span:not(.sold-out-message)') || button;
  const textLabelFor = (button) =>
    button.querySelector('span:not(.sold-out-message):not(.loading__spinner)') || button;

  const isLoading = (button) =>
    button.classList.contains('loading') || button.classList.contains('ht-desktop-quick-add-loading');

  const runLabelFadeIn = (button) => {
    if (button.dataset.htQuickAddFadePending !== 'true') return;
    delete button.dataset.htQuickAddFadePending;
    button.classList.remove('ht-quick-add-label-fading');
    button.classList.add('ht-quick-add-label-fade-in');
    window.clearTimeout(button.htQuickAddFadeTimer);
    button.htQuickAddFadeTimer = window.setTimeout(() => {
      button.classList.remove('ht-quick-add-label-fade-in');
    }, 220);
  };

  const setLoading = (button, isLoading) => {
    if (isLoading) {
      button.classList.remove('ht-quick-add-label-fading', 'ht-quick-add-label-fade-in');
    }

    if (window.matchMedia('(min-width: 750px)').matches) {
      button.classList.toggle('ht-desktop-quick-add-loading', isLoading);
      if (!isLoading) runLabelFadeIn(button);
      return;
    }

    button.classList.toggle('loading', isLoading);
    button.classList.toggle('ht-mobile-quick-add-loading', isLoading);
    button.querySelectorAll('.loading__spinner').forEach((spinner) => {
      spinner.classList.toggle('hidden', !isLoading);
    });
    if (!isLoading) runLabelFadeIn(button);
  };

  const clearLoadingButtons = () => {
    document
      .querySelectorAll(
        `${quickAddSelector}.loading, ${quickAddSelector}.ht-desktop-quick-add-loading, ${quickAddSelector}.ht-mobile-quick-add-loading`
      )
      .forEach((button) => setLoading(button, false));
  };

  const getVariantId = (button) => {
    const direct = button.dataset.htQuickAddVariant;
    if (direct) return String(direct).split('/').pop();

    const form = button.closest('form');
    const input = form?.querySelector('input[name="id"]');
    return input?.value ? String(input.value).split('/').pop() : '';
  };

  const setButton = (button, text, disabled) => {
    const label = textLabelFor(button);
    if (label.textContent !== text) {
      window.clearTimeout(button.htQuickAddFadeTimer);
      if (isLoading(button)) {
        label.textContent = text;
        button.dataset.htQuickAddFadePending = 'true';
      } else {
        button.classList.add('ht-quick-add-label-fading');
        button.htQuickAddFadeTimer = window.setTimeout(() => {
          label.textContent = text;
          button.classList.remove('ht-quick-add-label-fading');
          button.classList.add('ht-quick-add-label-fade-in');
          button.htQuickAddFadeTimer = window.setTimeout(() => {
            button.classList.remove('ht-quick-add-label-fade-in');
          }, 180);
        }, 120);
      }
    }
    if (button.disabled !== disabled) {
      button.disabled = disabled;
    }

    const form = button.closest('form');
    const variantInput = form?.querySelector('input[name="id"]');
    if (variantInput && button.dataset.htQuickAddBaseDisabled !== 'true') {
      if (variantInput.disabled !== disabled) {
        variantInput.disabled = disabled;
      }
    }
  };

  const fetchCart = (force = false) => {
    if (!force && cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((response) => (response.ok ? response.json() : { items: [] }))
      .catch(() => ({ items: [] }));

    return cartRequest;
  };

  const cartQuantities = (cart) => {
    const quantities = new Map();
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '').split('/').pop();
      if (!id) return;
      quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
    });
    return quantities;
  };

  const updateButton = (button, quantities) => {
    if (button.dataset.htQuickAddBaseDisabled === 'true') return;

    const limit = Number.parseInt(button.dataset.htQuickAddPurchaseLimit, 10);
    const variantId = getVariantId(button);
    if (!Number.isFinite(limit) || limit <= 0 || !variantId) return;

    const inCart = quantities.get(String(variantId).split('/').pop()) || 0;
    const remaining = Math.max(limit - inCart, 0);
    const defaultLabel = button.dataset.htQuickAddDefaultLabel || 'Add to cart';

    if (remaining <= 0) {
      setButton(button, 'Limit reached', true);
    } else if (inCart > 0) {
      setButton(button, `${defaultLabel} (${remaining} left)`, false);
    } else {
      setButton(button, defaultLabel, false);
    }
  };

  const refresh = async (force = false) => {
    const buttons = Array.from(document.querySelectorAll(selector));
    if (!buttons.length) {
      clearLoadingButtons();
      return;
    }

    const cart = await fetchCart(force);
    const quantities = cartQuantities(cart);
    buttons.forEach((button) => updateButton(button, quantities));
    clearLoadingButtons();
  };

  const scheduleRefresh = (force = false, delay = 80) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => refresh(force), delay);
  };

  document.addEventListener('DOMContentLoaded', () => {
    scheduleRefresh(true, 0);
  });
  window.addEventListener('pageshow', () => scheduleRefresh(true, 0));
  window.addEventListener('focus', () => scheduleRefresh(true, 0));

  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = event.target?.closest?.(quickAddSelector);
      if (!button || button.disabled) return;
      setLoading(button, true);
      window.clearTimeout(loadingTimer);
      loadingTimer = window.setTimeout(clearLoadingButtons, 1800);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!event.target?.matches?.('form[action*="/cart/add"]')) return;
      const button = event.target.querySelector(quickAddSelector);
      if (button && !button.disabled) {
        setLoading(button, true);
        window.clearTimeout(loadingTimer);
        loadingTimer = window.setTimeout(clearLoadingButtons, 1800);
      }
      cartRequest = null;
      scheduleRefresh(true, 1200);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const button = event.target?.closest?.(quickAddSelector);
    if (!button || button.disabled) return;
    setLoading(button, true);
    window.clearTimeout(loadingTimer);
    loadingTimer = window.setTimeout(clearLoadingButtons, 1800);
    if (!button.matches(selector)) return;
    cartRequest = null;
    scheduleRefresh(true, 1200);
  });

  new MutationObserver(() => {
    scheduleRefresh(false, 120);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.HobbyTigerQuickAddLimits = { refresh: () => scheduleRefresh(true, 0) };
})();
